/* tslint:disable */
/* eslint-disable */
/**
 * POS API
 * Internal POS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  GetBeepers200Response,
} from '../models/index';
import {
    GetBeepers200ResponseFromJSON,
    GetBeepers200ResponseToJSON,
} from '../models/index';

/**
 * 
 */
export class BeepersApi extends runtime.BaseAPI {

    /**
     */
    async getBeepersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetBeepers200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/beepers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetBeepers200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async getBeepers(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetBeepers200Response> {
        const response = await this.getBeepersRaw(initOverrides);
        return await response.value();
    }

}
